import React, { useState } from 'react';
import { Notification, Table } from 'react-bulma-components';
import { useFirebase } from '../Firebase';
import DiscoverRow from './row';
import { Discover } from './types';

type Props = {
  discovers: Discover[];
};

const DiscoversTable = function DiscoversTable({ discovers }: Props) {
  const firebase = useFirebase()!;
  const [notificationMessage, setNotificationMessage] = useState<string | null>(
    null
  );

  const deleteDiscover = async (id: string) => {
    const ref = firebase.db.collection('discoverStories').doc(id);
    await ref.delete();
  };

  const onDelete = async (id: string) => {
    // eslint-disable-next-line no-alert
    if (window.confirm(`You are about to delete a Discover Card: ${id}.`)) {
      try {
        await deleteDiscover(id);
        window.location.reload();
      } catch (error: any) {
        // console.log('onDelete ERR', error);
        setNotificationMessage(error.message);
      }
    }
  };

  return (
    <>
      {notificationMessage && (
        <Notification color="danger" colorVariant="light">
          <button
            aria-label="close"
            className="delete"
            onClick={() => setNotificationMessage(null)}
            type="button"
          />
          {notificationMessage}
        </Notification>
      )}
      <Table className="is-fullwidth is-hoverable">
        <thead>
          <tr>
            <th>
              <abbr title="Order">#</abbr>
            </th>
            <th>ID</th>
            <th>Title</th>
            <th>Thumbnail</th>
            <th>Subtitle</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {discovers
            .sort((a, b) => b.order - a.order)
            .map((discover) => (
              <DiscoverRow
                key={discover.id}
                discover={discover}
                onDelete={onDelete}
              />
            ))}
        </tbody>
      </Table>
    </>
  );
};

export default DiscoversTable;
